import React, {useEffect, useState} from "react"
import styled from "styled-components"
import {Link as RouterLink} from "@reach/router"
import {api} from "@indebted/api"
import {ErrorPage} from "@indebted/components/Error"
import {LoadingPage} from "@indebted/components/Loading"
import {Header} from "@indebted/components/Header"
import {Box, Breadcrumbs, Card, Link, Table, TableBody, TableCell, TableHead, TableRow} from "@material-ui/core"

import {Row} from "./Row"

function ClientFile() {
	const [data, setData] = useState()
	const [error, setError] = useState()
	const searchParams = new URLSearchParams(location.search)

	const [params] = useState({
		ClientID: searchParams.get("ClientID"),
		Directory: searchParams.get("Directory"),
		Filename: searchParams.get("Filename"),
	})

	useEffect(viewFile, [params])

	function viewFile() {
		api.clientFiles.view(params).then(setData).catch(setError)
	}

	if (error) return <ErrorPage message={error.Message} />
	if (!data) return <LoadingPage />

	const keys = Array.from(new Set(data.FileRows.map(Object.keys).flat()))
	const FileComponent = keys.length == 0 ? EmptyFileComponent : TableFileComponent

	return (
		<>
			<Header title="Client Error File">
				<Breadcrumbs>
					<Link component={RouterLink} to="/client-files">
						Client Files
					</Link>
					<div>{data.ClientName}</div>
					<div>{params.Directory}</div>
					<div>{params.Filename}</div>
				</Breadcrumbs>
			</Header>

			<FileComponent keys={keys} data={data} />
		</>
	)
}

function EmptyFileComponent() {
	return (
		<Card>
			<Box p={4}>Empty file</Box>
		</Card>
	)
}

function TableFileComponent({keys, data}) {
	return (
		<ScrollingCard>
			<TightTable>
				<TableHead>
					<TableRow>
						{keys.map((key, i) => (
							<TableCell key={i}>{key}</TableCell>
						))}
					</TableRow>
				</TableHead>
				<TableBody>
					{data.FileRows.map((row, i) => (
						<Row key={i} row={row} keys={keys} />
					))}
				</TableBody>
			</TightTable>
		</ScrollingCard>
	)
}

const ScrollingCard = styled(Card)`
	overflow: auto;
`

const TightTable = styled(Table)`
	td {
		white-space: nowrap;
		width: 1px;
	}

	td:last-child {
		width: auto;
	}
`

export {ClientFile}
